<template>
	<div>
		<v-navigation-drawer
			class="pa-0"
			fixed
			height="auto"
			right
			temporary
			stateless
			:width="width"
			v-model="value"
		>
			<section class="header-modal" :style="`background-color: ${headerColor}`">
				<header class="header-title">
					<h2>{{ title }}</h2>
					<v-btn
						class="ma-0"
						flat icon
						:disabled="isLoading"
						@click="closeDrawer"
					>
						<img v-if="imgSrc" :src="imgSrc" alt="">
						<v-icon v-else>arrow_forward</v-icon>
					</v-btn>
				</header>
			</section>
			<section class="content-modal">
				<slot></slot>
			</section>
		</v-navigation-drawer>
	</div>
</template>

<script>
function closeDrawer() {
	this.$emit('close-modal', false);
}

export default {
	name: 'action-sidebar',
	methods: {
		closeDrawer,
	},
	model: {
		prop: 'value',
		event: 'close-modal',
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			required: true,
		},
		width: {
			type: Number,
			default: 600,
		},
		codeAction: {
			type: String,
			required: false,
		},
		imgSrc: {
			type: String,
		},
		headerColor: {
			type: String,
			default: 'white',
		},
		isLoading: {
			default: false,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.navigation-drawer{
	height: 100%;
	padding: 0;
}
	.header-modal {
		border: 1px solid map-get($colors, grey);
		height: 39px;
		padding-left: 30px;
		.header-title {
			@include flex-between;
			color: map-get($colors, sidebar);

			h2 {
				color: map-get($colors, paginationText);
				font-family: map-get($fonts, open-semibold);
				font-size: map-get($sizes, medium20);
				text-transform: uppercase;
			}

			.btn {
				margin: 0;
			}
		}
	}
	.content-modal {
		background-color: lighten(map-get($colors, grey), 0.15);
		height: calc(100vh - 39px);
		overflow: auto;
		padding-bottom: 100px;
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/action-sidebar.vue